import React, { useState, useEffect } from "react";
import {
  fetchNetworkingStagesStatus,
  AddContactWidget,
  IsMobile,
  ClickToPhone,
  SocialLinks
} from "./SalientComponents";
import moment from "moment";

export const EventsWithContact = props => {
  const Event = ({ event, contact }) => {
    return (
      <div className={IsMobile() ? "event stack" : "event"}>
        <div className="title">
          {event.title}
          {event.type != null ? " - " + event.type : null}
        </div>
        {(contact != null && contact.name != null && contact.id != null && contact.firstName != null && contact.lastName != null) ? (
        <div className="contact">
          <i
            style={{
              fontSize: "30px",
              lineHeight: "70px",
              height: "70px",
              width: "70px",
              color: "#a3a3a3"
            }}
            className="fa fa-user-circle hover-off"
          />
          <a
            href={
              "/prism/contact-detail/" +
              contact.name.replace(/\s/g, "") +
              "/" +
              contact.id +
              "?tab=notifications&contactId=" +
              contact.id
            }
          >
            {contact.firstName + " " + contact.lastName}
          </a>
        </div>
        ) : null}{" "}
        <div>
          {(contact != null && contact.emailOne != null) ? (
            <a
              href={"mailto:" + contact.emailOne}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="icon-tiny fa fa-envelope-o extra-color-3" />
            </a>
          ) : null}{" "}
          {(contact != null && contact.phoneOne != null) ? (
          <ClickToPhone phone={contact.phoneOne} />
          ) : null}
        </div>
        {contact != null ? (
        <SocialLinks contact={contact} />
        ) : null}
      </div>
    );
  };

  return (
    <div className="dash">
      {props.events != null
        ? props.events.map(e => (
            <Event key={e.event.id} event={e.event} contact={e.contact} />
          ))
        : null}
    </div>
  );
};

export const FollowupsWithContact = ({ pairs, toggleCallback }) => {
  const Followup = ({ pair }) => {
    return (
      <div className={IsMobile() ? "followup stack" : "followup"}>
        <div className="title">
          <input
            key={"followUpComplete" + pair.followup.id}
            name={"followUpComplete" + pair.followup.id}
            type="checkbox"
            checked={pair.followup.complete !== "0"}
            onChange={() =>
              pair.followup.complete === "0"
                ? toggleCallback(pair.followup.id)
                : null
            }
          />
          {pair.followup.title}
        </div>
        {(pair.contact != null && pair.contact.name != null && pair.contact.id != null && pair.contact.firstName != null && pair.contact.lastName != null) ? (
        <div className="contact">      
          <i
            style={{
              fontSize: "30px",
              lineHeight: "70px",
              height: "70px",
              width: "70px",
              color: "#a3a3a3"
            }}
            className="fa fa-user-circle hover-off"
          />      
          <a
            href={
              "/prism/contact-detail/" +
              pair.contact.name.replace(/\s/g, "") +
              "/" +
              pair.contact.id +
              "?tab=notifications&contactId=" +
              pair.contact.id
            }
          >
            {pair.contact.firstName + " " + pair.contact.lastName}
          </a>        
        </div>
        ) : null}{" "}
        <div className="contactInfo">
          {(pair.contact != null && pair.contact.emailOne) ? (
            <a
              href={"mailto:" + pair.contact.emailOne}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="icon-tiny fa fa-envelope-o extra-color-3" />
            </a>
          ) : null}{" "}
          {(pair.contact != null && pair.contact.phoneOne != null) ? (
          <ClickToPhone phone={pair.contact.phoneOne} />
          ) : null}
        </div>
        {pair.contact != null ? (
        <SocialLinks contact={pair.contact} />
        ) : null}
      </div>
    );
  };

  return (
    <div className="dash">
      {pairs != null
        ? pairs.map(e => <Followup key={e.followup.id} pair={e} />)
        : null}
    </div>
  );
};

const DashboardPage = props => {
  const [statuses, setStatuses] = useState([]);
  const [categories, setCategories] = useState(null);
  const [open, setOpen] = useState(false);
  const [followupPairs, setFollowupPairs] = useState([]);
  const [eventPairs, setEventPairs] = useState([]);

  useEffect(() => {
    const loadEvents = async wordpressId => {
      await fetch("/wp-json/prism/v1/events-with-contacts/" + wordpressId, {
        headers: { "X-WP-Nonce": props.nonce }
      })
        .then(response => response.json())
        .then(result => setEventPairs(result));
    };
    if (props.wordpressId != null && props.nonce != null)
      loadEvents(props.wordpressId);
  }, [props.wordpressId, props.nonce]);

  useEffect(() => {
    const fetchCategories = async ({ id, nonce }) => {
      await fetch("/wp-json/prism/v1/categories/" + id, {
        headers: { "X-WP-Nonce": nonce }
      })
        .then(response => response.json())
        .then(result => setCategories(result));
    };

    if (props.wordpressId != null && props.nonce != null) {
      fetchNetworkingStagesStatus({
        wordpressId: props.wordpressId,
        callback: setStatuses,
        nonce: props.nonce
      });
      fetchCategories({ id: props.wordpressId, nonce: props.nonce });
    }
  }, [props.wordpressId, props.nonce]);

  const fetchFollowups = async wordpressId => {
    await fetch("/wp-json/prism/v1/followups-with-contacts/" + wordpressId, {
      headers: { "X-WP-Nonce": props.nonce }
    })
      .then(response => response.json())
      .then(result => setFollowupPairs(result));
  };

  const toggleFollowup = async followupId => {
    await fetch("/wp-json/prism/v1/toggle-followup/", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": props.nonce
      },
      body: JSON.stringify({
        contactId: props.contactId,
        followupId: followupId
      })
    }).then(response => fetchFollowups(props.wordpressId));
  };

  useEffect(() => {
    const fetchFollowupsInit = async wordpressId => {
      await fetch("/wp-json/prism/v1/followups-with-contacts/" + wordpressId, {
        headers: { "X-WP-Nonce": props.nonce }
      })
        .then(response => response.json())
        .then(result => setFollowupPairs(result));
    };
    if (props.wordpressId != null && props.nonce != null)
      fetchFollowupsInit(props.wordpressId);
  }, [props.wordpressId, props.nonce]);

  return (
    <div>
      <div
        data-column-margin="default"
        data-midnight="dark"
        data-top-percent="4%"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row top-level full-width-section  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section "
        style={{ paddingTop: "calc(100vw * 0.04)", paddingBottom: 0 }}
      >
        <div
          className="row-bg-wrap"
          data-bg-animation="none"
          data-bg-overlay="false"
        >
          <div className="inner-wrap">
            <div className="row-bg" />
          </div>
          <div className="row-bg-overlay" />
        </div>
        <div className="col span_12 dark left">
          <div
            className="vc_col-sm-12 vc_hidden-lg wpb_column column_container vc_column_container col padding-3-percent"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="right"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div
                  id="fws_5e7bcd84266ac"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section    "
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <h1 style={{ textAlign: "center" }}>
                                <span style={{ color: "#05bff7" }}>
                                  Welcome, {props.wordpressName}
                                </span>
                              </h1>
                              <p style={{ textAlign: "center" }}>
                                Today is {moment().format("dddd, MMMM Do YYYY")}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="fws_5e7bcd84270ec"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section    "
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-4 wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <form method="get" action="/prism/contact/">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center"
                                  }}
                                >
                                  <i className="icon-tiny iconsmind-Magnifi-Glass22 extra-color-2" />
                                  <input
                                    type="text"
                                    name="q"
                                    placeholder="Search Contacts"
                                    style={{ padding: "5px" }}
                                  />
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-4 wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element  vc_custom_1584730324426">
                            <div className="wpb_wrapper">
                              <h6
                                className="clickable"
                                onClick={() => setOpen(true)}
                              >
                                <span style={{ color: "#1e83ec" }}>
                                  <i className="icon-normal fa fa-plus-circle extra-color-gradient-2" />
                                  Add Contact
                                </span>
                              </h6>
                              <AddContactWidget open={open} setOpen={setOpen} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-4 wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element  vc_custom_1584730305467">
                            <div className="wpb_wrapper">
                              <select
                                onChange={e =>
                                  (window.location.href =
                                    "/prism/contact/?c=" + e.target.value)
                                }
                              >
                                <option>Search Categories</option>
                                {categories != null
                                  ? categories.map(c => (
                                      <option value={c.name}>{c.name}</option>
                                    ))
                                  : null}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="fws_5e7bcd84283dc"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column centered-text padding-3-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element  vc_custom_1584825698926">
                            <div className="wpb_wrapper">
                              <h2 style={{ textAlign: "center" }}>
                                <span style={{ color: "#05bff7" }}>Today </span>
                                <i className="icon-default-style fa fa fa-bell-o extra-color-2" />
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="toggles " data-style="minimal">
                  <div className="toggle accent-color">
                    <h3>
                      <a href="#">
                        <i className="icon-plus-sign" />
                        Follow-Ups
                      </a>
                    </h3>
                    <div>
                      <div
                        id="fws_5e7bcd8429212"
                        data-midnight=""
                        data-column-margin="default"
                        data-bg-mobile-hidden=""
                        className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                        style={{ paddingTop: 0, paddingBottom: 0 }}
                      >
                        <div className="row-bg-wrap">
                          <div className="row-bg   " />
                        </div>
                        <div className="col span_12  left">
                          <div
                            className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column no-extra-padding"
                            data-t-w-inherits="default"
                            data-shadow="none"
                            data-border-radius="none"
                            data-border-animation=""
                            data-border-animation-delay=""
                            data-border-width="none"
                            data-border-style="solid"
                            data-border-color=""
                            data-bg-cover=""
                            data-padding-pos="all"
                            data-has-bg-color="false"
                            data-bg-color=""
                            data-bg-opacity="1"
                            data-hover-bg=""
                            data-hover-bg-opacity="1"
                            data-animation=""
                            data-delay="0"
                          >
                            <div className="vc_column-inner">
                              <div
                                className="column-bg-overlay-wrap"
                                data-bg-animation="none"
                              >
                                <div className="column-bg-overlay" />
                              </div>
                              <div className="wpb_wrapper">
                                <FollowupsWithContact
                                  wordpressId={props.wordpressId}
                                  nonce={props.nonce}
                                  pairs={followupPairs}
                                  toggleCallback={toggleFollowup}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="toggle accent-color">
                    <h3>
                      <a href="#">
                        <i className="icon-plus-sign" />
                        Events
                      </a>
                    </h3>
                    <div>
                      <div
                        id="fws_5e7bcd842ae63"
                        data-midnight=""
                        data-column-margin="default"
                        data-bg-mobile-hidden=""
                        className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                        style={{ paddingTop: 0, paddingBottom: 0 }}
                      >
                        <div className="row-bg-wrap">
                          <div className="row-bg   " />
                        </div>
                        <div className="col span_12  left">
                          <div
                            className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column no-extra-padding"
                            data-t-w-inherits="default"
                            data-shadow="none"
                            data-border-radius="none"
                            data-border-animation=""
                            data-border-animation-delay=""
                            data-border-width="none"
                            data-border-style="solid"
                            data-border-color=""
                            data-bg-cover=""
                            data-padding-pos="all"
                            data-has-bg-color="false"
                            data-bg-color=""
                            data-bg-opacity="1"
                            data-hover-bg=""
                            data-hover-bg-opacity="1"
                            data-animation=""
                            data-delay="0"
                          >
                            <div className="vc_column-inner">
                              <div
                                className="column-bg-overlay-wrap"
                                data-bg-animation="none"
                              >
                                <div className="column-bg-overlay" />
                              </div>
                              <div className="wpb_wrapper">
                                <EventsWithContact
                                  wordpressId={props.wordpressId}
                                  nonce={props.nonce}
                                  events={eventPairs}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-column-margin="default"
        data-midnight="dark"
        data-top-percent="4%"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row full-width-section  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section "
        style={{ paddingTop: "calc(100vw * 0.04)", paddingBottom: 0 }}
      >
        <div
          className="row-bg-wrap"
          data-bg-animation="none"
          data-bg-overlay="false"
        >
          <div className="inner-wrap">
            <div className="row-bg" />
          </div>
          <div className="row-bg-overlay" />
        </div>
        <div className="col span_12 dark left">
          <div
            className="vc_col-sm-12 vc_hidden-md vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col padding-3-percent"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="right"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div
                  id="fws_5e7bcd842e2fd"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section    "
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      style={{ marginBottom: "2%!important" }}
                      className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <h1 style={{ textAlign: "center" }}>
                                <span style={{ color: "#05bff7" }}>
                                  Welcome, {props.wordpressName}
                                </span>
                              </h1>
                              <p style={{ textAlign: "center" }}>
                                Today is {moment().format("dddd, MMMM Do YYYY")}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="fws_5e7bcd842ead4"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section    "
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-4 wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element  vc_custom_1584730324426">
                            <div className="wpb_wrapper">
                              <form method="get" action="/prism/contact/">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center"
                                  }}
                                >
                                  <i className="icon-tiny iconsmind-Magnifi-Glass22 extra-color-2" />
                                  <input
                                    type="text"
                                    name="q"
                                    placeholder="Search Contacts"
                                    style={{ padding: "5px" }}
                                  />
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-4 wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <h6
                                className="clickable"
                                style={{ textAlign: "center" }}
                                onClick={() => setOpen(true)}
                              >
                                <i className="icon-normal fa fa-plus-circle extra-color-gradient-2" />
                                <span style={{ color: "#1e83ec" }}>
                                  Add Contact
                                </span>
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-4 wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element  vc_custom_1584730305467">
                            <div className="wpb_wrapper">
                              <select
                                onChange={e =>
                                  (window.location.href =
                                    "/prism/contact/?c=" + e.target.value)
                                }
                              >
                                <option>Search Categories</option>
                                {categories != null
                                  ? categories.map(c => (
                                      <option value={c.name}>{c.name}</option>
                                    ))
                                  : null}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="fws_5e7bcd842fd53"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      style={{ marginTop: "3%" }}
                      className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column centered-text padding-3-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="left-right"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element  vc_custom_1584825698926">
                            <div className="wpb_wrapper">
                              <h2 style={{ textAlign: "center" }}>
                                <span style={{ color: "#05bff7" }}>Today </span>
                                <i className="icon-default-style fa fa fa-bell-o extra-color-2" />
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_content_element" data-interval="0">
                  <div
                    className="wpb_wrapper tabbed clearfix"
                    data-style="default"
                    data-spacing="side-30px"
                    data-icon-size=""
                    data-full-width-line=""
                    data-color-scheme="accent-color"
                    data-alignment="center"
                  >
                    <ul className="wpb_tabs_nav ui-tabs-nav clearfix">
                      <li>
                        <a href="#tab-1585013574682-7">
                          <span>Follow-Ups</span>
                        </a>
                      </li>
                      <li>
                        <a href="#tab-1585013575350-10">
                          <span>Events</span>
                        </a>
                      </li>
                    </ul>

                    <div
                      id="tab-follow-ups"
                      data-tab-icon=""
                      className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                    >
                      <FollowupsWithContact
                        wordpressId={props.wordpressId}
                        nonce={props.nonce}
                        pairs={followupPairs}
                        toggleCallback={toggleFollowup}
                      />
                    </div>
                    <div
                      id="tab-events"
                      data-tab-icon=""
                      className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                    >
                      <EventsWithContact
                        wordpressId={props.wordpressId}
                        nonce={props.nonce}
                        events={eventPairs}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="nectar-cta "
                  data-color="default"
                  data-using-bg="false"
                  data-style="see-through"
                  data-display="block"
                  data-alignment="left"
                  data-text-color="custom"
                >
                  <h6 style={{ color: "#1e83ec" }}>
                    <span className="text"> </span>
                    <span className="link_wrap">
                      <a className="link_text" href="/notifications/">
                        View Future Dates
                        <span className="arrow" />
                      </a>
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="results"
        data-column-margin="default"
        data-midnight="dark"
        data-top-percent="5%"
        data-bottom-percent="2%"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row full-width-section  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section "
        style={{
          paddingTop: "calc(100vw * 0.05)",
          paddingBottom: "calc(100vw * 0.02)"
        }}
      >
        <div
          className="row-bg-wrap"
          data-bg-animation="none"
          data-bg-overlay="false"
        >
          <div className="inner-wrap">
            <div className="row-bg" />
          </div>
          <div className="row-bg-overlay" />
        </div>
        <div className="col span_12 dark left">
          <div
            className="vc_col-sm-12 wpb_column column_container vc_column_container col no-extra-padding"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="all"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <h2
                  style={{ color: "#05bff7", textAlign: "center" }}
                  className="vc_custom_heading"
                >
                  Quick Links
                </h2>
                <div
                  id="fws_5e7bcd8453ed1"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section    "
                  style={{ paddingTop: "3%", paddingBottom: 0 }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-1/5 vc_hidden-md vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/contact/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Recently Added Contacts</span>
                                  <i className="fa fa-history" />
                                </a>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/contact/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Contacts</span>
                                  <i className="fa fa-address-book-o" />
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-1/5 vc_hidden-md vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/networking/#stages"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Networking Process</span>
                                  <i className="fa fa fa-tasks" />
                                </a>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/prism-networking-resources/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Networking Resources</span>
                                  <i className="iconsmind-Book" />
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-1/5 vc_hidden-md vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/notifications/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Notifications</span>
                                  <i className="fa fa fa-bell-o" />
                                </a>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/help/getting-started-guide/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Getting Started Guide</span>
                                  <i className="fa fa fa-file-text-o" />
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-1/5 vc_hidden-md vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/option-c/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Mentoring Series</span>
                                  <i className="iconsmind-Laser" />
                                </a>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/option-c/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Mentoring Relationships</span>
                                  <i className="iconsmind-Affiliate" />
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-1/5 vc_hidden-md vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/help/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Help Center</span>
                                  <i className="fa fa fa-question" />
                                </a>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/subscription-account/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Account Settings</span>
                                  <i className="fa fa fa-user-o" />
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="fws_5e7bcd8459bde"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section    "
                  style={{ paddingTop: "3%", paddingBottom: 0 }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-12 vc_hidden-lg wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/contact/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Recently Added Contacts</span>
                                  <i className="fa fa-history" />
                                </a>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/contact/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Contacts</span>
                                  <i className="fa fa-address-book-o" />
                                </a>
                              </p>
                            </div>
                          </div>

                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/networking/#stages"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Networking Process</span>
                                  <i className="fa fa fa-tasks" />
                                </a>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/prism-networking-resources/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Networking Resources</span>
                                  <i className="iconsmind-Book" />
                                </a>
                              </p>
                            </div>
                          </div>

                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/notifications/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Notifications</span>
                                  <i className="fa fa fa-bell-o" />
                                </a>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/help/getting-started-guide/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Getting Started Guide</span>
                                  <i className="fa fa fa-file-text-o" />
                                </a>
                              </p>
                            </div>
                          </div>

                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/option-c/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Mentoring Series</span>
                                  <i className="iconsmind-Laser" />
                                </a>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/option-c/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Mentoring Relationships</span>
                                  <i className="iconsmind-Affiliate" />
                                </a>
                              </p>
                            </div>
                          </div>

                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/help/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Help Center</span>
                                  <i className="fa fa fa-question" />
                                </a>
                                <a
                                  className="nectar-button n-sc-button small see-through-2 has-icon"
                                  href="/subscription-account/"
                                  data-color-override="#1e83ec"
                                  data-hover-color-override="#1e83ec"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span style={{ width: "135px" }}>Account Settings</span>
                                  <i className="fa fa fa-user-o" />
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="results"
        data-column-margin="default"
        data-midnight="dark"
        data-top-percent="5%"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row full-width-section  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section "
        style={{ paddingTop: "calc(100vw * 0.05)", paddingBottom: 0 }}
      >
        <div
          className="row-bg-wrap"
          data-bg-animation="none"
          data-bg-overlay="false"
        >
          <div className="inner-wrap">
            <div className="row-bg" />
          </div>
          <div className="row-bg-overlay" />
        </div>
        <div className="col span_12 dark left">
          <div
            className="vc_col-sm-12 wpb_column column_container vc_column_container col no-extra-padding"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="all"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <h2
                  style={{ color: "#05bff7", textAlign: "center" }}
                  className="vc_custom_heading"
                >
                  PRISM Networking Process
                </h2>
                <div
                  id="fws_5e7bcd845c57e"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section    "
                  style={{ paddingTop: "3%", paddingBottom: 0 }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-4 wpb_column column_container vc_column_container col child_column centered-text padding-3-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="3px"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="1px"
                      data-border-style="solid"
                      data-border-color="#a3a3a3"
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div
                        className="vc_column-inner"
                        style={{ border: "1px solid #a3a3a3" }}
                      >
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div
                            className="nectar-milestone "
                            data-symbol=""
                            data-symbol-alignment="default"
                            data-symbol-pos="after"
                            data-symbol-size="62"
                            data-ms-align="default"
                          >
                            <div
                              className="number extra-color-2"
                              data-number-size="62"
                            >
                              <span>
                                {statuses.Active != null ? statuses.Active : 0}
                              </span>
                            </div>
                            <div className="subject">
                              Of Your Contacts are Active in PRISM Process
                            </div>
                          </div>
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <a
                                  className="nectar-button n-sc-button small accent-color has-icon regular-button"
                                  href="/contact/?networkingProcess=Active"
                                  data-color-override="false"
                                  data-hover-color-override="false"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span>View Active Contacts</span>
                                  <i className="iconsmind-Loading-3" />
                                </a>
                                <br />
                                <a
                                  className="nectar-button n-sc-button small accent-color has-icon regular-button"
                                  href="/contact/?networkingProcess=Inactive"
                                  data-color-override="false"
                                  data-hover-color-override="false"
                                  data-hover-text-color-override="#fff"
                                >
                                  <span>View Inactive Contacts</span>
                                  <i className="iconsmind-Close-Window" />
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-8 wpb_column column_container vc_column_container col child_column padding-5-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="left-right"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <h3>Contacts in the PRISM Process</h3>
                              <p>Click the number to view your contacts</p>
                            </div>
                          </div>

                          <div
                            className="divider-wrap"
                            data-alignment="default"
                          >
                            <div
                              style={{ height: "25px" }}
                              className="divider"
                            />
                          </div>
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <table id="dash">
                                <thead>
                                  <tr>
                                    <th className="blank">Status</th>
                                    <th style={{ textAlign: "center" }}>
                                      <i className="icon-tiny iconsmind-Wrench extra-color-3" />
                                      BUILD
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      <i className="icon-tiny iconsmind-Search-People extra-color-3" />
                                      DISCOVER
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      <i className="icon-tiny iconsmind-Plastic-CupPhone extra-color-3" />
                                      CONNECT
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      <i className="icon-tiny iconsmind-Puzzle extra-color-3" />
                                      ASSESS
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      <i className="icon-tiny iconsmind-Checked-User extra-color-3" />
                                      ENGAGE
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      <i className="icon-tiny iconsmind-Heart2 extra-color-3" />
                                      MAINTAIN
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <i className="icon-tiny iconsmind-Sand-watch2 extra-color-3" />
                                      In Progress
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <a href="/contact/?networkingStage=0&networkingStatus=In%20Progress">
                                        {statuses.BuildInProgress != null
                                          ? statuses.BuildInProgress
                                          : 0}
                                      </a>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <a href="/contact/?networkingStage=1&networkingStatus=In%20Progress">
                                        {statuses.DiscoverInProgress != null
                                          ? statuses.DiscoverInProgress
                                          : 0}
                                      </a>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <a href="/contact/?networkingStage=2&networkingStatus=In%20Progress">
                                        {statuses.ConnectInProgress != null
                                          ? statuses.ConnectInProgress
                                          : 0}
                                      </a>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <a href="/contact/?networkingStage=3&networkingStatus=In%20Progress">
                                        {statuses.AssessInProgress != null
                                          ? statuses.AssessInProgress
                                          : 0}
                                      </a>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <a href="/contact/?networkingStage=4&networkingStatus=In%20Progress">
                                        {statuses.EngageInProgress != null
                                          ? statuses.EngageInProgress
                                          : 0}
                                      </a>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <a href="/contact/?networkingStage=5&networkingStatus=In%20Progress">
                                        {statuses.MaintainInProgress != null
                                          ? statuses.MaintainInProgress
                                          : 0}
                                      </a>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <i className="icon-tiny iconsmind-Yes extra-color-3" />
                                      Complete
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <a href="/contact/?networkingStage=0&networkingStatus=Complete">
                                        {statuses.BuildComplete != null
                                          ? statuses.BuildComplete
                                          : 0}
                                      </a>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <a href="/contact/?networkingStage=1&networkingStatus=Complete">
                                        {statuses.DiscoverComplete != null
                                          ? statuses.DiscoverComplete
                                          : 0}
                                      </a>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <a href="/contact/?networkingStage=2&networkingStatus=Complete">
                                        {statuses.ConnectComplete != null
                                          ? statuses.ConnectComplete
                                          : 0}
                                      </a>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <a href="/contact/?networkingStage=3&networkingStatus=Complete">
                                        {statuses.AssessComplete != null
                                          ? statuses.AssessComplete
                                          : 0}
                                      </a>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <a href="/contact/?networkingStage=4&networkingStatus=Complete">
                                        {statuses.EngageComplete != null
                                          ? statuses.EngageComplete
                                          : 0}
                                      </a>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <a href="/contact/?networkingStage=5&networkingStatus=Complete">
                                        {statuses.MaintainComplete != null
                                          ? statuses.MaintainComplete
                                          : 0}
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="results"
        data-column-margin="default"
        data-midnight="dark"
        data-top-percent="3%"
        data-bottom-percent="2%"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row full-width-section  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section "
        style={{
          paddingTop: "calc(100vw * 0.03)",
          paddingBottom: "calc(100vw * 0.02)"
        }}
      >
        <div
          className="row-bg-wrap"
          data-bg-animation="none"
          data-bg-overlay="false"
        >
          <div className="inner-wrap">
            <div className="row-bg" />
          </div>
          <div className="row-bg-overlay" />
        </div>
        <div className="col span_12 dark left">
          <div
            className="vc_col-sm-6 wpb_column column_container vc_column_container col no-extra-padding"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="all"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
